import { render } from "./index.vue?vue&type=template&id=152ed706&scoped=true"
import script from "./editor-button.js?vue&type=script&lang=js"
export * from "./editor-button.js?vue&type=script&lang=js"

import "./editor-button.scss?vue&type=style&index=0&id=152ed706&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152ed706"]])

export default __exports__